import { message } from 'antd'
import { fetchUtil as fetch } from 'src/utils/fetch'
import { saveAuditData } from 'src/api/audit'

export const getTreasureHunter = async (page, size, name = '') => {
  try {
    const { data } = await fetch('/metaverse-rooms/treasure/searchAdmin', {
      method: 'POST',
      body: JSON.stringify({
        size: size,
        page: page,
        name: name,
      }),
      headers: {
        role: 'ADMIN',
      },
    })
    return data
  } catch (e) {
    message.error('Search Treasure Hunter Error !')
  }
}

export const saveEditTreasureHunter = async (
  id,
  title,
  desc,
  instruction,
  titleFr,
  descFr,
  instructionFr,
  titleAr,
  descAr,
  instructionAr,
  img,
  thumbImage,
  accessLevels,
  enabled,
  complex,
  retentionDepth,
  monetizationModel,
  tier
) => {
  try {
    const input = new FormData()
    input.append(
      'treasureEditDto',
      new Blob(
        [
          JSON.stringify({
            id: id,
            title: title,
            description: desc,
            instruction: instruction,
            titleFr: titleFr,
            descriptionFr: descFr,
            instructionFr: instructionFr,
            titleAr: titleAr,
            descriptionAr: descAr,
            instructionAr: instructionAr,
            accessLevels: accessLevels,
            enabled: enabled,
            complex: complex,
            retentionDepth: retentionDepth,
            monetizationModel: monetizationModel,
            tier: tier,
          }),
        ],
        {
          type: 'application/json',
        }
      )
    )
    input.append('image', img)
    input.append('thumbImage', thumbImage)

    const { data } = await fetch('/metaverse-rooms/treasure/edit', {
      method: 'POST',
      body: input,
      headers: {
        role: 'ADMIN',
      },
    })
    saveAuditData('EDIT', 'Treasure Hunter', id)
    message.success('Success Edit Treasure Hunter!')
    return 'success'
  } catch (e) {
    message.error('Error Edit Treasure Hunter!')
    return 'failed'
  }
}

export const getTopUser = async (id, country) => {
  try {
    const { data } = await fetch(
      `/metaverse-rooms/treasure/top/${id}/admin/${country}`
    )
    return data
  } catch (e) {
    message.error('Leaderboard Treasure Hunter Error !')
  }
}
